export default class DadosRegistroModel {
    public nu_certificado :number;
    public no_responsavel :string;
    public nu_cpf :number;
    public co_certificado :string;
    public de_nome_comum :string;
    public no_autoridade_certificadora :string;
    public nu_perfil :number;
    public nu_pis :number;
    public nu_entidade_certificada :number;
    public de_razao_social :string;
    public nu_inscricao :string;
    public de_perfil :string;
    public ic_tipo_perfil :number;
    public ic_tipo_restricao :number;
    public situacao :number;
    public bloqueado :boolean;
}